import { sitemapCities } from "../sitemap";
import { IMenuItem, ISocials } from "../types";

export const footerDetails: {
  subheading: string;
  quickLinks: IMenuItem[];
  email: string;
  telephone?: string;
  socials: ISocials;
  contactHeader: string;
  quickLinksHeader: string;
  resourcesHeader: string;
  resources: IMenuItem[];
  locations: typeof sitemapCities;
  locationsHeader: string;
} = {
  subheading: "Professionell webbutveckling och apputveckling för småföretag och startups i Sverige.",
  quickLinks: [
    { text: "Om Dataeden", url: `#about` },
    { text: "Varför välja oss?", url: `#features` },
    { text: "Tidigare projekt", url: `#projects` },
    { text: "Vanliga frågor", url: `#faq` },
    { text: "Kontakta oss", url: `#cta` },
  ],
  resources: [
    { text: "Blogg – alla guider", url: "/blog" },
    { text: "Vad kostar SEO?", url: "/blog/vad-kostar-seo-i-sverige" },
    { text: "Bästa bokföringsprogram för småföretag", url: "/blog/basta-bokforingsprogram-smaforetag" },
  ],
  locations: sitemapCities,
  email: "johannes@dataeden.se",
  socials: {
    linkedin: "https://www.linkedin.com/in/johannesedenholm",
  },
  contactHeader: "Kontaktuppgifter",
  quickLinksHeader: "Snabblänkar",
  resourcesHeader: "Resurser",
  locationsHeader: "Vi arbetar i dessa områden",
};
